'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'GOOGLE_MAPS',
	name: 'Google Maps',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Social',
	props: [{
		name: 'apiKey',
		inputType: 'text',
		label: 'Google API key',
		default: ''
	}, {
		name: 'lat',
		inputType: 'text',
		label: 'Latitude',
		default: ''
	}, {
		name: 'lng',
		inputType: 'text',
		label: 'Longitude',
		default: ''
	}, {
		name: 'zoom',
		inputType: 'select',
		label: 'Initial zoom',
		default: '14',
		values: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18']
	}, {
		name: 'height',
		inputType: 'text',
		label: 'Height',
		default: '500px'
	}, {
		name: 'title',
		inputType: 'text',
		label: 'Marker title',
		default: ''
	}, {
		name: 'icon',
		inputType: 'media',
		label: 'Marker icon',
		default: ''
	}, {
		name: 'theme',
		inputType: 'select',
		label: 'Theme',
		default: 'Standard',
		values: ['Standard', 'Silver', 'Retro', 'Dark', 'Night', 'Aubergine']
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'Info window settings',
		props: [{
			name: 'header',
			inputType: 'text',
			label: 'Header',
			default: ''
		}, {
			name: 'description',
			inputType: 'textarea',
			label: 'Text',
			default: 'Text...'
		}, {
			name: 'image',
			inputType: 'media',
			label: 'image',
			default: ''
		}]
	})
};